module.exports = __webpack_public_path__ + "img/caoutchouc.80a44ea2.webp";